export const URL = "https://api.themoviedb.org/3"
export const posterURL342 = "https://image.tmdb.org/t/p/w342"
export const posterURL500 = "https://image.tmdb.org/t/p/w500"
export const posterURL780 = "https://image.tmdb.org/t/p/w780"
export const backdropURL = "https://image.tmdb.org/t/p/w1280"
export const profileURL = "https://image.tmdb.org/t/p/w185"